import { Pipe, PipeTransform } from '@angular/core';
import {
  PaymentFrequency,
  ProtectionDetailsPaymentOption,
  RegisteredItemProductDetails,
} from '@us-registration/util-models';

@Pipe({ name: 'registeredItemMonthlyOrAnnuallyLabel', standalone: true })
export class RegisteredItemMonthlyOrAnnuallyLabelPipe implements PipeTransform {
  transform(
    registeredItemProductDetails?:
      | RegisteredItemProductDetails
      | ProtectionDetailsPaymentOption
  ): string {
    if (!registeredItemProductDetails) {
      return '';
    }

    return registeredItemProductDetails.paymentFrequency ===
      PaymentFrequency.Monthly
      ? PaymentFrequency.Monthly
      : PaymentFrequency.Annually;
  }
}
